import { Skeleton, Stack } from '@mui/material';
import type { FC } from 'react';

export const ListPendingView: FC = () => (
  <Stack spacing={3}>
    <Skeleton variant="rounded" height="3rem" />
    <Skeleton variant="rounded" height="3rem" />
  </Stack>
);
